import { Fragment } from 'react';
import {
  Grid,
  Box,
  Typography,
  useTheme,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TableHead,
  TableBody,
  Table,
  TableCell,
} from '@mui/material';

import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import useTableForm from '../../hooks/useTableForm';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const radioId = [
  'no5_1',
  'no5_2',
  'no5_3',
  'no5_4',
  'no5_5',
  'no5_6',
  'no5_7',
  'no5_8',
];

const contentLabel = [
  {
    id: 1,
    ko: '① 가족의 지지',
    desc: ['가족들의 정서적, 경제적인 지원이 지속적으로 있다고 느끼십니까?'],
  },
  {
    id: 2,
    ko: '② 진통제 복용 순응도',
    desc: ['과거에 의사가 처방하는 진통제를 규칙적으로 복용하셨습니까?'],
  },
  {
    id: 3,
    ko: '③ 스트레스 대처유형',
    desc: [
      '암 진단 이전에 스트레스를 느끼는 경우 적극적으로 해결하는 편이었습니까?',
    ],
  },
  {
    id: 4,
    ko: '④ 환자의 불안, 우울 등 최근 감정상태',
    desc: ['최근 들어 불안하거나 우울하십니까?'],
  },
  {
    id: 5,
    ko: '⑤ 현재처한 환자 자신의 영적 고뇌',
    desc: [
      '삶의 가치, 존재의미, 현재상황에 대한 혼란, 죄책감, 괴로움 등이 있으십니까?',
    ],
  },
  {
    id: 6,
    ko: '⑥ 자기조절능력 소실 유무',
    desc: ['자신의 감정이나 행동을 조절하기 어렵다고 느끼십니까?'],
  },
  {
    id: 7,
    ko: '⑦ 약물 남용 및 의존',
    desc: [
      '술, 항불안제(진정제, 수면제), 마약 등을 남용하거나 의존한 적이 있으습니까?',
    ],
  },
  {
    id: 8,
    ko: '⑧ 정신과적 기왕력',
    desc: ['과거에 우울증, 신경증, 정신병 등으로 치료를 받은 적이 있으십니까?'],
  },
];

const PainEffect = (props: Props) => {
  const { palette } = useTheme();
  const { radioGroup } = useTableForm(props);
  const { disabled, getValues, setValue } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
  };

  return (
    <Fragment>
      <SectionTitle title="5. 통증에 영향을 미치는 심리사회적 항목들" mb={2} />
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          marginBottom: '10px',
          marginLeft: '3px',
        }}
      >
        다음의 항목 중 해당사항에 표시하세요.
      </Typography>
      <Grid item xs={12} sx={{ marginBottom: '60px' }}>
        <div style={{ display: 'table-row' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ display: 'block', marginLeft: '1.3889vw' }}>
                <TableCell align="right" sx={{ display: 'flex' }}>
                  <Typography
                    sx={{
                      marginRight: '10px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    아니오
                  </Typography>
                  <Typography
                    sx={{
                      marginRight: '105px',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    예
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contentLabel.map(
                (content: { id: number; ko: string; desc: string[] }, i) => {
                  return (
                    <TableRow sx={{ display: 'block', marginLeft: '1.3889vw' }}>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          paddingLeft: '1.388vw',
                          paddingTop: '16px',
                          paddingBottom: '16px',
                          width: '300px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                          fontWeight: 400,
                        }}
                      >
                        {content.ko}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="center"
                        sx={{
                          padding: '16px',
                          width: '70px',
                          whiteSpace: 'nowrap',
                        }}
                      ></StyledTableCellTwo>
                      <StyledTableCellWithoutLeftRightTwo>
                        {content.desc.map((v, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '44px',
                                lineHeight: '44px',
                              }}
                            >
                              <Box
                                sx={{
                                  paddingLeft: '10px',
                                  minWidth: '700px',
                                  fontSize: '12px',
                                  fontWeight: 400,
                                }}
                              >
                                {v}
                              </Box>
                            </TableRow>
                          );
                        })}
                      </StyledTableCellWithoutLeftRightTwo>
                      <StyledTableCellWithoutLeftTwo sx={{ width: '180px' }}>
                        <RadioGroup
                          name={radioId[content.id - 1]}
                          defaultValue={Number(
                            getValues(radioId[content.id - 1])
                          )}
                        >
                          {content.desc.map((_, i) => (
                            <TableRow
                              sx={{
                                height: '44px',
                                lineHeight: '44px',
                                textAlign: 'center',
                              }}
                            >
                              <Box
                                sx={{
                                  width: '164px',
                                }}
                              >
                                <FormControlLabel
                                  sx={{ paddingRight: '100px' }}
                                  label=""
                                  control={
                                    <Radio
                                      disabled={disabled}
                                      name={radioId[content.id - 1]}
                                      value={i}
                                      onChange={handleChange}
                                    />
                                  }
                                />
                                <FormControlLabel
                                  label=""
                                  control={
                                    <Radio
                                      disabled={disabled}
                                      name={radioId[content.id - 1]}
                                      value={i + 1}
                                      onChange={handleChange}
                                    />
                                  }
                                />
                              </Box>
                            </TableRow>
                          ))}
                        </RadioGroup>
                      </StyledTableCellWithoutLeftTwo>
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table>
        </div>
      </Grid>
    </Fragment>
  );
};

export default PainEffect;
